import React from 'react';

const EmployeeFullName = (props) => {

  return (
    <span onClick={() => props.toggleEmployeeModal(props.row)} className={`${props.className} dashed-link`}>{`${props.row.firstName} ${props.row.lastName}`}</span>
  );
}

export default EmployeeFullName;